import React from 'react';
import { SVGDefaultProps } from './types';
import { colors } from '@/styles';

export const Help = ({
  size = 16,
  title = 'Help',
  fill = colors.silverSandAlt,
}: SVGDefaultProps) => {
  const height = Number(size) * 2.85;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 31 31">
      {Boolean(title) && <title>{title}</title>}
      <path
        d={`
M24.75,4.24A14.5,14.5,0,1,0,14.49,29h0A14.5,14.5,0,0,0,24.75,4.24ZM26.8,
14.5A12.28,12.28,0,0,1,14.52,26.8h0A12.3,12.3,0,1,1,26.8,14.5Z
`}
        fill={fill}
      />
      <path
        d={`
M13.2,16.15a3.14,3.14,0,0,1,.16-1,2.11,2.11,0,0,1,.54-.77c.37-.36.71-.67,
1-.94a10.1,10.1,0,0,0,.8-.74,4.07,4.07,0,0,0,.53-.65,1.26,1.26,0,0,0,.19-.65,
1.31,1.31,0,0,0-.41-1A1.48,1.48,0,0,0,15,10a1.81,1.81,0,0,0-1.41.52,2,2,0,0,
0-.55,1.25L10,11.57a4.54,4.54,0,0,1,1.53-3.21A5.2,5.2,0,0,1,15,7.26a5.8,5.8,
0,0,1,1.71.25,4.19,4.19,0,0,1,1.42.74,3.6,3.6,0,0,1,1,1.23,3.81,3.81,0,0,1,
.36,1.69,4.05,4.05,0,0,1-.12,1,3,3,0,0,1-.4.92,5.23,5.23,0,0,1-.76.93,14.38,14.38,
0,0,1-1.18,1,2,2,0,0,0-.62.7,1.56,1.56,0,0,0-.15.67V17h-3ZM12.87,20a1.7,1.7,0,0,
1,.14-.71,1.93,1.93,0,0,1,.38-.59,1.79,1.79,0,0,1,.59-.39,2,2,0,0,1,1.43,0,1.65,
.65,0,0,1,.58.39,1.79,1.79,0,0,1,.39.59,1.84,1.84,0,0,1,0,1.42,1.76,1.76,0,0,
1-1,1,2,2,0,0,1-1.43,0,1.76,1.76,0,0,1-1-1,1.7,1.7,0,0,1-.14-.71Z
`}
        fill={fill}
      />
    </svg>
  );
};
